import createReactClass from 'create-react-class'
import React from 'react'
import AnalysisFormPanel from './analysis-form-panel'
import AnalysisResult from './analysis-result-panel'
import './analysis-panel.scss'

export default createReactClass({
  backToSearchPage () {
    this.props.history.push('/search')
  },
  render () {
    return (
      <div className='container'>
        <div>
          <button className='cs-secondary-button' onClick={this.backToSearchPage}>
            <span className='fa fa-caret-left'/>
            Back
          </button>
        </div>
        <div className="search-panel">
          <div className="csc-panel">
            <div className="panel-body">
              <h4 className="card-title">
                Analysis
              </h4>
              <AnalysisFormPanel {...this.props} />
            </div>
          </div>
        </div>
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Usage Logs
              {this.props.totalSize > 0
                ? <div className='count-box pull-right'>Total count:
                  <span className='value-color'>{this.props.totalSize}</span></div>
                : ''}
            </h4>
            <AnalysisResult {...this.props} list={this.props.logs}/>
          </div>
        </div>
      </div>
    )
  },
  componentDidMount () {
    this.props.getUserDetails(this.props.getUserAccessActions)
  },
})



// WEBPACK FOOTER //
// ./src/components/analysis-page/analysis-panel.js